import { TemaCard } from "@/components/TemaCard";

/** Colori del gestionale: raggiungibile da tutto il personale, non solo dal titolare. */
export default function Colori() {
  return (
    <div className="fade-up mx-auto max-w-2xl space-y-5" data-testid="colori-page">
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-slate-400">Questo dispositivo</p>
        <h1 className="text-4xl font-bold sm:text-5xl">Colori</h1>
      </div>
      <TemaCard />
    </div>
  );
}
